<!-- Vue component -->
<template>
   <div class="form__field">
    <div class="form__input">
      <v-swatches v-model="color" :swatches="swatches" @close="emitColor" >
        <input slot="trigger" class="form__input__element" readonly style="width: 30px; cursor:pointer">
      </v-swatches>
    </div>
  </div>
</template>

<script>
import VSwatches from 'vue-swatches'

// Import the styles too, typically in App.vue or main.js
import 'vue-swatches/dist/vue-swatches.css'

export default {
  components: { VSwatches },
  props: ['projectColor'],
  data() {
    return {
      color: null,
      swatches: [
                "#ff78786E",
                "#ff91786E", 
                "#ffae786E", 
                "#ffd2786E", 
                "#fff4786E",
                "#d7ff786E",
                "#b9ff786E",
                "#95ff786E",
                "#78ff936E",
                "#78ffc96E",
                "#78fffd6E",
                "#78c2ff6E",
                "#7883ff6E",
                "#a578ff6E",
                "#d478ff6E",
                "#ff78fa6E",
                "#ff78976E",
                "#ff788c6E",
                "#6019196E",
                ""
                ]
    }
  },
  created(){
      this.color = this.projectColor;
  },
  methods:{
      emitColor(){
          this.$emit('emitColor', this.color);
      }
  }
}
</script>

<style scoped>

</style>
